// Input a string without hash sign of RGB hex digits to compute complementary contrasting color such as for fonts
export const getContrastColor = (color) => {
    const hex = color.replace(/#/, '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    return [0.299 * r, 0.587 * g, 0.114 * b].reduce((a, b) => a + b) / 255;
};
